// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__tCGvM","loader_loading":"Loader_loader_loading__-rit0"};